/**
 * Specific dashlet for form dialogs (i.e. dialogs with form)
 */
hrd.AbstractFormPopup = hrd.AbstractPopup.extend({
	init: function(popup, options) {
		var size = dashboardInstance.isDoubleSize() ? '2x' : '1x';
		var defaults = {
			impl: 'hrd.AbstractFormPopup',
			size: size,
			initialData: undefined
		};
		this._super(popup, $.extend({}, defaults, options));
	},
	getFormInstance: function() {
		return this.$dialog.data('form-instance');
	},
	getFormData: function(storeData, options) {
		var fi = this.getFormInstance();
		return fi ? (storeData ? fi.settings.inputData : fi.toObject(undefined, options)) : {};
	},
	getInitialData: function() {
		return $.extend(true, {}, this.settings.initialData); // a deep new copy
	},
	changeFieldLabel: function(field, label) {
		this.getFormInstance().changeFieldLabel(field, label);
	},
	show: function(data, opts, formOptions) {
		opts = opts || {};
		opts.noRef = true;
		let snippetsConfig = this.getSnippetsConfig();
		let p;
		if (snippetsConfig !== undefined) {
			p = $.when(this.doSnippets(snippetsConfig));
		} else {
			p = $.when();
		}
		return p.then(() => this.openFormDialog(data, opts, formOptions));
	},
	getSnippetsConfig: $.noop,
	doSnippets: function(snippetsConfig) {
		const toHtmlContainerId = (key) => $.functionCase(`${key}-snippet-container`);
		const toHtmlContainer = (key) => $(`<div id="${toHtmlContainerId(key)}" class="ui-helper-hidden"></div>`);

		// Check if already present before downloading
		let toBeDownloaded = {};
		Object.keys(snippetsConfig).forEach(key => {
			if (!$(`#${toHtmlContainerId(key)}`).exists()) {
				// copy entry if not already downloaded
				toBeDownloaded[key] = snippetsConfig[key];
			}
		});

		return dashboardInstance.downloadSnippets(toBeDownloaded)
			.then((snippets) => {
				Object.entries(snippets).forEach(snippetDef => {
					let key = snippetDef[0];
					let snippetInfo = snippetDef[1];
					let $container = toHtmlContainer(key);
					$container.append(snippetInfo.snippet);
					$('body').append($container);
				});
			});
	},
	destroyOnClose: function() {
		const toHtmlContainerId = (key) => $.functionCase(`${key}-snippet-container`);
		let snippetsConfig = this.getSnippetsConfig();
		if (snippetsConfig) {
			Object.keys(snippetsConfig).forEach(key => {
				let id = `#${toHtmlContainerId(key)}`;
				if ($(id).exists()) {
					$(id).remove();
				}
			});
		}
	},
	openFormDialog: function(data, opts, formOptions) {
		opts = opts || {};
		formOptions = formOptions || {};
		if (opts.noRef !== true) {
			opts.reference = this;
			delete opts.noRef; // not needed anymore, can be romoved
		}
		if (typeof this.dialogOptions === 'function') {
			opts = $.extend({}, this.dialogOptions.call(this), opts);
		}
		// could happen that this.$dialog is not really instantiated, because html part is created via factory
		if (this.$dialog == undefined || !this.$dialog.exists()) {
			this.$dialog = $(this.DIALOG_ID);
		}

		// add data-popup if missing. needed for programmatic dialogs
		if (this.$dialog.data('popup') == undefined) {
			this.$dialog.data('popup', "{type: 'form'}");
		}
		let promise = hrd.form.showFormDialog(this.DIALOG_ID, data, opts, formOptions);

		var dialogImpl = this.$dialog.data('dialogImpl') || this; // effective dialog or *this* if undefined

		if (typeof dialogImpl['executeProceedAction'] === 'function') {
			// return a promise resolved with formData, dialogOptions and all the returned values of the 'executeProceedAction' method
			return promise.then((formData, dialogOptions) => {
				let otherPromise = dialogImpl['executeProceedAction'].call(dialogImpl, formData, dialogOptions);
				return $.when(otherPromise).then(function() {
					let array = [formData, dialogOptions];
					array = array.concat(Array.prototype.slice.call(arguments));
					return $.when.apply($, array);
				});
			});
		} else {
			return promise;
		}
	},
	enableButton: function(btn, endWaiting) {
		let $btn = this.getFormInstance().getField(btn);
		if (!$btn.exists()) {
			// cerca se esiste il pulsante tra i bottoni del form come data-action (o come class-name)
			let dButtons = this.getDialog().dialog('option', 'buttons');
			if (dButtons) {
				let pane = this.getDialogButtonPane();
				$btn = pane.find(`button[data-action="${btn}"], button.${btn}`);
			}
		}

		if ($btn.exists()) {
			$btn.button('enable');
			if (endWaiting === true) {
				$btn.waiting('done');
			}
		}
	},
	disableButton: function(btn, startWaiting) {
		let $btn = this.getFormInstance().getField(btn);
		if (!$btn.exists()) {
			// cerca se esiste il pulsante tra i bottoni del form come data-action (o come class-name)
			let dButtons = this.getDialog().dialog('option', 'buttons');
			if (dButtons) {
				let pane = this.getDialogButtonPane();
				$btn = pane.find(`button[data-action="${btn}"], button.${btn}`);
			}
		}

		if ($btn.exists()) {
			$btn.button('disable');
			if (startWaiting === true) {
				$btn.waiting();
			}
		}
	},
	showButton: function($btn) {
		this.getFormInstance().showField($btn);
	},
	hideButton: function($btn) {
		this.getFormInstance().hideField($btn);
	}
});